import { render, staticRenderFns } from "./AppLoader.vue?vue&type=template&id=74d7e7ec"
import script from "./AppLoader.vue?vue&type=script&lang=js"
export * from "./AppLoader.vue?vue&type=script&lang=js"
import style0 from "./AppLoader.vue?vue&type=style&index=0&id=74d7e7ec&prod&lang=css"


/* normalize component */
import normalizer from "!D:\\projects\\xena\\node_modules\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports